import ContentHeader from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import "./../Expenses/Expenses.css";
import TransactionNavigation from "../../components/Transaction-comp/Navigation/TransactionYearNavigation";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASEURL } from "../../constant/constant";
import TransactionYear from "../../components/Transaction-comp/TransactionYear";
import TransactionMonth from "../../components/Transaction-comp/TransactionMonth";
import TransactionMonthNavigation from "../../components/Transaction-comp/Navigation/TransactionMonthNavigation";
import { useLocation } from "react-router-dom";

const TransactionMonthMain = () => {
  const { state } = useLocation();
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [month_payment_list, setMonth_payment_list] = useState("");

  const MonthPaymentList = async (showSkeleton = false) => {
    const auth_token = sessionStorage.getItem("auth_token");
    showSkeleton && setIsLoading(true);
    const response = await axios({
      url: BASEURL + "transaction/monthly",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: auth_token,
      },
      data: {
        year: state.year,
      },
    });
    setMonth_payment_list(response.data);
    showSkeleton && setIsLoading(false);
  };

  useEffect(() => {
    MonthPaymentList(true);
  }, []);

  return (
    <div className="col-md-12 content">
      <Sidebar
        className="sidebar-main"
        isActive={isActive}
        setIsActive={setIsActive}
        classNameTwo="open-sidebar"
      />
      <div className="col-12 sb-content">
        <div className="sb-content-header">
          <ContentHeader setIsActive={setIsActive} />
        </div>
        <div className="sb-nav">
          <TransactionMonthNavigation />
        </div>
        <div className="content-index">
          <div className="content-scroll">
            <div class="content-card card">
              <TransactionMonth
                month_payment_list={month_payment_list}
                isLoading={isLoading}
                state={state}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionMonthMain;
